import { FilterOptionItem } from "@orderna/admin-panel/src/types/filter";
import { PlanInterval as PlanInterval } from '@orderna/admin-panel/src/app/model/enum/plan-interval';

export const PLAN_INTERVAL_OPTIONS: FilterOptionItem<PlanInterval>[] = [
  {
    label: 'Monthly',
    value: PlanInterval.MONTHLY,
  },
  {
    label: 'Semi-annually',
    value: PlanInterval.SEMI_ANNUALLY,
  },
  {
    label: 'Annually',
    value: PlanInterval.ANNUALLY,
  },
]